import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Translate } from '../../contexts/Language';
import './login.css';
import { AuthConsumer } from '../../contexts/Auth';
import { Validator } from '../../components/Validator';
import LoginForm from '../../components/authentication/LoginForm';
import { Service } from '../../services';
import AuthenticatorForm from '../../components/authentication/AuthenticatorForm';

export class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        AccountLogin: null,
        Password: null,
        AuthenticatorCode: null,
      },
      validation: {
        error: false,
        message: '',
      },
      authenticatorData: {
        QrImageUrl: null,
        AuthenticatorKey: null,
      },
      passAuthenticatorStep: false,
    };
    this.onChange = this.onChange.bind(this);
    this.onLogin = this.onLogin.bind(this);
    this.isValid = this.isValid.bind(this);
    this.onPreLogin = this.onPreLogin.bind(this);
  }

  onChange(e) {
    const { formData } = this.state;

    formData[e.target.name] = e.target.value;

    this.setState({
      formData,
    });
  }

  onLogin(e, loginHandler) {
    const { formData } = this.state;

    if (this.isValid()) {
      loginHandler(formData, this.loadingHandler, e);

      // if (!AuthConsumer.isAuth)
      //     this.setState({
      //         validation: {
      //             error: true,
      //             message: Translate('Invalid Login Credentials')
      //         }
      //     });
    }
  }

  onPreLogin() {
    const { formData } = this.state;
    const model = {
      AccountLogin: formData.AccountLogin,
      Password: formData.Password,
    };
    Service.User.PreLogin(model).then(response => {
      if (response && response.success !== true) {
        this.setState({
          validation: {
            error: true,
            message: response.message,
          },
        });
      } else {
        this.setState({
          passAuthenticatorStep: true,
          authenticatorData: {
            QrImageUrl: response.qrImageUrl,
            AuthenticatorKey: response.authenticatorKey,
          },
        });
      }
    });
  }

  isValid() {
    const { formData } = this.state;

    const error = Validator.Valid(formData, this.Refs);

    this.setState({
      validation: error,
    });

    return !error.error;
  }

  render() {
    const { validation, formData, passAuthenticatorStep, authenticatorData } = this.state;
    return (
      <AuthConsumer>
        {({ authorized, onLogin }) => (
          (authorized) ?
            <Redirect to="/home" />
            : (
              <div className="wrapper-page">
                <div className="card account-card mx-3">
                  <div className="bg-info p-4 text-white text-center position-relative">
                    <h4 className="font-20 m-b-5">{Translate('Personnel Panel')}</h4>
                    <p className="text-white-50 mb-4">{Translate('Money transfer management panel.')}</p>
                    <Link to="/login" className="logo logo-admin"><img src="assets/images/gilden-logo.png" height="24" alt="logo" /></Link>
                  </div>
                  {
                    // <div className="account-card-content">
                    //   <ErrorMessage Validation={validation} />
                    //   {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                    //   <form className="form-horizontal m-t-30" name="loginForm" onKeyPress={e => { if (e.key === 'Enter') { onLogin(formData); } }}>
                    //     <div className="form-group">
                    //       <label htmlFor="username">{Translate('User Id')}</label>
                    //       <input type="email" className="form-control" id="AccountLogin" name="AccountLogin" placeholder={Translate('Enter user id')} onChange={e => this.onChange(e)} />
                    //     </div>

                    //     <div className="form-group">
                    //       <label htmlFor="userpassword">{Translate('Password')}</label>
                    //       <input type="password" className="form-control" id="Password" name="Password" placeholder={Translate('Enter password')} onChange={e => this.onChange(e)} />
                    //     </div>

                    //     <div className="form-group row m-t-20">
                    //       <div className="col-sm-6">
                    //         <LanguageList />
                    //       </div>
                    //       <div className="col-sm-6 text-right">
                    //         <button type="button" className="btn btn-info w-md waves-effect waves-light" onClick={e => { this.onLogin(e, onLogin); }}>{Translate('Log In')}</button>
                    //       </div>
                    //     </div>
                    //     <div className="form-group m-t-10 mb-0 row">
                    //       <div className="col-12 m-t-20">
                    //         <Link to="/recoverpassword">
                    //           <i className="mdi mdi-lock mr-2" />
                    //           <span>Forgot your password?</span>
                    //         </Link>
                    //       </div>
                    //     </div>
                    //   </form>
                    // </div>
                  }
                  {
                    passAuthenticatorStep ? (
                      <AuthenticatorForm
                        formData={formData}
                        validation={validation}
                        onChange={this.onChange}
                        onLogin={onLogin}
                        authenticatorData={authenticatorData}
                      />

                    ) : (
                      <LoginForm
                        formData={formData}
                        validation={validation}
                        onChange={this.onChange}
                        onLogin={this.onPreLogin}
                      />
                    )}

                </div>
                <div className="m-t-40 text-center">
                  <p>{`© ${new Date().getFullYear()} TRA Information Technologies `}</p>
                </div>
              </div>
            )
        )}
      </AuthConsumer>
    );
  }
}
